export default {"field":"cvarx","textareaField":"MxY6X","checkboxField":"M02PI"};